import {
    GET_ALERT_LIST_SUCCESS,
    GET_ALERT_LIST_FAILURE,
    GET_GENERAL_NEWS_LIST_SUCCESS,
    GET_GENERAL_NEWS_LIST_FAILURE,
    UPDATE_READ_STATUS_SUCCESS,
    UPDATE_READ_STATUS_FAILURE
} from "./action";
const initialState = {
    alertListSuccess: [],
    alertListFailure: [],
    readStatusError: []
}

const alertsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALERT_LIST_SUCCESS:
            return state = {
                ...state,
                alertListSuccess: action.data
            }
        case GET_ALERT_LIST_FAILURE:
            return state = {
                ...state,
                alertListFailure: action.data
            }
        case GET_GENERAL_NEWS_LIST_SUCCESS:
            return state = {
                ...state,
                generalNewsListSuccess: action.data
            }
        case GET_GENERAL_NEWS_LIST_FAILURE:
            return state = {
                ...state,
                generalNewsListFailure: action.data
            }
        case UPDATE_READ_STATUS_SUCCESS:
            return state = {
                ...state,
                alertListSuccess: action.data
            }
        case UPDATE_READ_STATUS_FAILURE:
            return state = {
                ...state,
                readStatusError: action.data
            }
        default: return state;
    }
}
export default alertsReducer;
